var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
//Copied from packages/bg-studio/src/files/components/UploadSingleImage.tsx
import { FileUploadProvider, FileUploadState, getCookies, } from "@biggeo/bg-common";
import { UploadResourceType } from "@biggeo/bg-server-lib/studio";
import isEqual from "lodash/isEqual";
import React from "react";
import { Button, CircularLoading } from "../components";
import { UploadOutline } from "../icons";
export const UploadSingleImage = (_a) => {
    var { overwrite, callbacks } = _a, props = __rest(_a, ["overwrite", "callbacks"]);
    const uploadOptions = {
        overwrite,
        fileTypes: ["image/*"],
        cookies: getCookies(props.app),
        onError: (err, file) => {
            var _a;
            (_a = callbacks.onError) === null || _a === void 0 ? void 0 : _a.call(callbacks, err.message, file);
        },
        onSuccess: (file) => {
            var _a;
            (_a = callbacks.onSuccess) === null || _a === void 0 ? void 0 : _a.call(callbacks, file);
        },
        onLoad: () => {
            var _a;
            (_a = callbacks.onFetch) === null || _a === void 0 ? void 0 : _a.call(callbacks);
        },
        onProgress: (progress, file) => {
            var _a;
            (_a = callbacks.onProgress) === null || _a === void 0 ? void 0 : _a.call(callbacks, progress, file);
        },
        uploadResourceType: UploadResourceType.normal,
    };
    return (React.createElement(FileUploadProvider, { uploadOptions: uploadOptions }, ({ input, onClick, file }) => (React.createElement(React.Fragment, null,
        props.withButton ? (React.createElement(Button, Object.assign({ variant: "outlined", density: "dense", onClick: onClick, startNode: isEqual(file.state, FileUploadState.loading) ? (React.createElement(CircularLoading, { size: "xs" })) : (props.startIcon || (React.createElement(UploadOutline, { size: "xs" }))), endNode: props.endIcon, disabled: isEqual(file.state, FileUploadState.loading) ||
                props.disabled }, props.buttonProps), props.label || "Upload Image")) : (props.children({
            onClick,
            file,
        })),
        input))));
};
//# sourceMappingURL=UploadSingleImage.js.map